<div class="detailed-report-block-row-right">
	<button mat-button class="exit-button-icon" [disableRipple]="true" (click)="closeDialog()"
	type="button" mat-icon-button>
		<mat-icon svgIcon="md:close"></mat-icon>
	</button>
</div>
<div class="detailed-report-block-row">
	<div>
		<span class="detailed-report-title" translate>sb.detailed.report</span>
		<span class="detailed-report-title" translate>sb.choose.options</span>
	</div>
	<div>
		<form [formGroup]="detailedReportFormGroup">
			<div>
				<mat-label translate>sb.type</mat-label>
				<div class="publication-labels">
					<mat-radio-group formControlName="type">
						<mat-radio-button class="spacing" value="N">Net</mat-radio-button>
						<mat-radio-button class="spacing" value="C">Cumulative</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
			<div>
				<mat-label translate>sb.period</mat-label>
				<div class="publication-labels">
					<mat-radio-group formControlName="period">
						<mat-radio-button class="spacing" value="C">Daily</mat-radio-button>
						<mat-radio-button class="spacing" value="W">Weekly</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
			<div class="detailed-report-block-row-right">
				<button cdkFocusInitial class="detailed-report-button" type="submit" mat-button
				(click)="downloadReport()" >
					<span class="share-view-button-name" translate>sb.Download</span>
				</button>
				<button class="detailed-report-button" type="submit" mat-button
				(click)="closeDialog()" >
					<span class="share-view-button-name" translate>sb.Cancel</span>
				</button>
			</div>
		</form>
	</div>
</div>